<app-buy-thankyou-content
  [headline]="thankyouContentData.headline"
  [content]="thankyouContentData.content"
  [showBackrouteButton]="thankyouContentData.showBackrouteButton"
  [documentation]="thankyouContentData.documentation"
  [backrouteButton]="thankyouContentData.backrouteButton"
  (openDocumentationEvent)="openDocumentation()"
  (openBackrouteEvent)="openBackroute()"
></app-buy-thankyou-content>
